import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumbs, Typography, makeStyles } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles({
    breadcrumb: {
        marginTop: 30,
        marginLeft: 15
    },
    link: {
        textDecoration: 'none',
        color: '#555',
        '&:hover': {
            textDecoration: 'underline',
            color: '#2196f3' // Change to a blue color on hover
        }
    }
});

const pathNameMap = {
    "smart-search": "Smart Search",
    "smart-cma": "Smart CMA",
    "new-cma": "New CMA",
    "smart-reports": "Smart Reports",
    "smart-marketing": "Smart Marketing",
    "new-smart-report": "New Seller Report",
    "designs": "Designs",
    "listingad": "Listing Ad",
    "contacts": "Contacts",
    "precon": "Pre-construction E-mail",
    "preview": "Preview",
    // ":category": "Email",
    // ... Add more as needed
};

const Breadcrumb = () => {
    const classes = useStyles();
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter(x => x);

    return (
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" className={classes.breadcrumb}>
            <Link to="/" className={classes.link}>Home</Link>
            {pathnames.map((name, index) => {
                const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                const isLast = index === pathnames.length - 1;

                // Check if the current segment is after "contacts", and if so, rename it to "Client Preferences"
                if (pathnames[index - 1] === 'contacts') {
                    name = 'Client Preferences';
                }

                const readableName = pathNameMap[name] || name;

                return isLast ? (
                    <Typography color="textPrimary" key={name} style={{ fontWeight: 'bold', color: '#2196f3' }}>
                        {readableName}
                    </Typography>
                ) : (
                    <Link key={name} to={routeTo} className={classes.link}>
                        {readableName}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};

export default Breadcrumb;
